import { useCallback, useEffect, useRef, useState } from 'react';
import '/assets/styles/sections/active-order-list.scss';

// Partials
import Icon from '@wearetla/tla-essentials-tools/partials/icon';
import Link from '@wearetla/tla-essentials-tools/partials/link';

// Context
import { useAuth } from '@wearetla/tla-essentials-tools/utilities/auth';
import { useTranslation } from '/utilities/i18n';

// Services
import orderServices from '/services/order';

const ActiveOrderList = () => {
	const { loggedIn } = useAuth();
	const { t } = useTranslation();

	const [activeOrders, setActiveOrders] = useState(null);
	const fetchTimer = useRef(null);

	const checkOrder = useCallback(() => {
		orderServices
			.getActiveOrders()
			.then((activeOrders) => {
				setActiveOrders(
					activeOrders.map((order) => ({
						...order,
						status_text:
							order.status_text ??
							(() => {
								if (order.status === 1) {
									return t('Hazırlanıyor.');
								}
								if (order.status === 2) {
									return t('Teslim edildi.');
								}
							})(),
					}))
				);
			})
			.catch(() => {
				setActiveOrders(null);
			});
	}, []);

	useEffect(() => {
		if (loggedIn) {
			checkOrder();

			fetchTimer.current = setInterval(checkOrder, 30000);
		} else {
			if (fetchTimer.current) {
				clearInterval(fetchTimer.current);
			}
		}

		return () => {
			if (fetchTimer.current) {
				clearInterval(fetchTimer.current);
			}
		};
	}, [checkOrder, loggedIn]);

	if (!activeOrders?.length) {
		return null;
	}

	return (
		<section className="section active-order-status wrapper">
			{activeOrders.map((order) => (
				<Link
					href="account.orderDetail"
					params={{ id: order.id }}
					className="status-order"
					key={order.id}
				>
					<Icon name="order" className="status-icon" />

					<strong className="status-text">{order.status_text}</strong>

					<div className="status-orderinfo">
						<strong className="orderinfo-title">{t('Sipariş Numarası:')}</strong>
						{order.erp_code ? (
							<span className="orderinfo-number">{order.erp_code}</span>
						) : (
							<div className="orderinfo-spinnerwrap">
								<Icon className="orderinfo-spinner" name="spinner" />
							</div>
						)}
					</div>
				</Link>
			))}
		</section>
	);
};

export default ActiveOrderList;
